/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Radio } from '@design-system-coopeuch/web';
// styles
import { StyledRadioButtonDropdown , WrapperRadio} from './styles';


const RadioButtonDropdown = (props) => {
  const { children, hasContent, name, label, checked, disabled, onChange ,id} = props;
  /* istanbul ignore next */
  const [isCollapsed, setIsCollapsed] = useState(true);
  /* istanbul ignore next */
  useEffect(() => {
    if (checked) setIsCollapsed(false);
    else setIsCollapsed(true);
  }, [checked]);
  return (
    <StyledRadioButtonDropdown>
      <article
        className={`dropdown-head 
          ${checked ? 'dropdown-checked-head' : ''}
          ${isCollapsed === true ? 'dropdown-collapsed-head' : ''}
          ${disabled === true ? 'dropdown-disabled-head' : ''}
        `}
      >
        <WrapperRadio>
          <Radio
            name={name}
            label={label}
            checked={checked}
            disabled={disabled}
            onChange={onChange}
          />
        </WrapperRadio>
        {hasContent && (
          <button
            type="button"
            className="btn-without-format--red-underline"
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            {/* <img
              src={`${isCollapsed ? iconDropdownArrowBottom : iconDropdownArrowTop}`}
              width="14"
              alt=""
            /> */}
          </button>
        )}
      </article>
      {hasContent && !isCollapsed &&(
        <article className="content position-static">{children}</article>
      )}
      

    </StyledRadioButtonDropdown>
  );
};

export default RadioButtonDropdown;
